import React from 'react';

type StatusColor =
    | 'green'
    | 'red'
    | 'yellow'
    | 'amber'
    | 'purple'
    | 'blue'
    | 'gray';

const COLOR_CLASSES: Record<StatusColor, string> = {
    green: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    red: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
    yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
    amber: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
    purple: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400',
    blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
    gray: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
};

type SemanticStatus =
    | 'active'
    | 'inactive'
    | 'approved'
    | 'rejected'
    | 'pending'
    | 'paused';

const STATUS_MAP: Record<
    SemanticStatus,
    { color: StatusColor; label: string }
> = {
    active: { color: 'green', label: 'Activo' },
    inactive: { color: 'red', label: 'Inactivo' },
    approved: { color: 'green', label: 'Aprobado' },
    rejected: { color: 'red', label: 'No aprobado' },
    pending: { color: 'yellow', label: 'Pendiente' },
    paused: { color: 'purple', label: 'Pausado' },
};

interface StatusBadgeProps {
    status?: SemanticStatus;
    label?: string;
    color?: StatusColor;
    className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
    status,
    label,
    color,
    className = '',
}) => {
    const resolved = status ? STATUS_MAP[status] : null;
    const colorClass = COLOR_CLASSES[color ?? resolved?.color ?? 'gray'];
    const text = label ?? resolved?.label ?? '';

    return (
        <span
            className={`inline-flex rounded-full px-2 text-xs leading-5 font-semibold ${colorClass} ${className}`}
        >
            {text}
        </span>
    );
};

export default StatusBadge;
